import React, { useState } from "react";
import { Box } from "../../atoms/Box";
import { FileInput } from "../../molecules/FIleInput";
import { uploadFileRequest } from "../../../Service/utils";

const BioDataForm = () => {
  const [status, setStatus] = useState<String>("");
  const [progress, setProgress] = useState<Number>(0);

  const onChange = async (formData: FormData) => {
    const response = await uploadFileRequest(formData, (event) => {
      setStatus("INFO");
      setProgress(Math.round((event.loaded * 100) / event.total));
    });
    console.log(response);
    if (response.status == 200) {
      setStatus("SUCCESS");
    }

    if (response.status != 200) {
      setStatus("ERROR");
    }
  };

  const ErrorMessage = () => {
    return (
      <div
        className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
        role="alert"
      >
        <span className="block sm:inline">
          Something went wrong file didnt uploaded please use different method!
        </span>
        <button onClick={() => setStatus("")}>
          <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg
              className="fill-current h-6 w-6 text-red-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </button>
      </div>
    );
  };

  const InfoMessage = () => {
    return (
      <div
        className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative"
        role="alert"
      >
        <span className="block sm:inline">Uploading ({progress} %)</span>
        <button onClick={() => setStatus("")}>
          <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg
              className="fill-current h-6 w-6 text-blue-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </button>
      </div>
    );
  };

  const SuccessMessage = () => {
    return (
      <div
        className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative"
        role="alert"
      >
        <span className="block sm:inline">File Uploaded Successfully</span>
        <button onClick={() => setStatus("")}>
          <span className="absolute top-0 bottom-0 right-0 px-4 py-3">
            <svg
              className="fill-current h-6 w-6 text-green-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </button>
      </div>
    );
  };

  return (
    <Box>
      {/* {status != "" && (
        <div className="p-5">
          {status == "ERROR" && <ErrorMessage />}
          {status == "INFO" && <InfoMessage />}
          {status == "SUCCESS" && <SuccessMessage />}
        </div>
      )} */}
      {/* <div>Leave your Biodata and Horoscope here</div> */}
      {/* <div className="my-4">
        <FileInput
          label="Upload Single File"
          uploadFileName="theFiles"
          onChange={onChange}
        />
      </div> */}
      <div className="gap-2 flex flex-col md:flex-row">
        WhatsApp:{" "}
        <a
          href="whatsapp://send?text=&phone=:+919428356535"
          className="underline cursor-pointer"
        >
          +91 9428356535
        </a>{" "}
        OR Email:{" "}
        <a
          href="mailto:hemaparikh4@gmail.com"
          className="underline cursor-pointer"
        >
          hemaparikh4@gmail.com
        </a>
      </div>
    </Box>
  );
};

export { BioDataForm };
